import React, { useState } from 'react';
import PropTypes from 'prop-types';
import GoogleButton from 'react-google-button';

import EmailPasswordControlSet from '../../ControlSets/EmailPasswordControlSet/EmailPasswordControlSet';
import { UamErrorText, UamErrorTextContainer } from '../../../../styles-and-themes/styles/uam-registration-styles';
import LoginForgotControlSet from '../../ControlSets/LoginForgotControlSet/LoginForgotControlSet';
import { composeDestinationQuerystring } from '../../../../../shared-with-server/destination-utils';
import { destinationInfo } from '../../../../destructured-front-end-config';
import { GoogleButtonContainer } from './LoginPanelStyles';

const LoginPanel = ({
  destPath, errorMessage, setSubmitData, includeGoogleSignIn, initialEmail,
}) => {
  const [email, setEmail] = useState(initialEmail || '');
  const [password, setPassword] = useState('');

  const isFormValid = email.length > 0 && password.length > 0;

  const onLogin = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    setSubmitData({
      email,
      password,
      ...(destPath),
    });
  };

  return (
    <>
      <UamErrorTextContainer>
        <UamErrorText>
          {errorMessage || 'All fields are required'}
        </UamErrorText>
      </UamErrorTextContainer>

      <form onSubmit={onLogin}>
        <EmailPasswordControlSet
          email={email}
          setEmail={setEmail}
          password={password}
          setPassword={setPassword}
        />

        <LoginForgotControlSet
          onLogin={onLogin}
          isFormValid={isFormValid}
          destPath={destPath}
        />
      </form>
      {
        includeGoogleSignIn && (
          <GoogleButtonContainer>
            <GoogleButton onClick={() => {
              window.location.href = `/auth/google?${composeDestinationQuerystring(destinationInfo, destPath)}`;
            }}
            />
          </GoogleButtonContainer>
        )
      }
    </>
  );
};

LoginPanel.propTypes = {
  destPath: PropTypes.shape({
    dest: PropTypes.string,
    path: PropTypes.string,
    retURL: PropTypes.string,
  }).isRequired,
  errorMessage: PropTypes.string,
  setSubmitData: PropTypes.func.isRequired,
  includeGoogleSignIn: PropTypes.bool.isRequired,
  initialEmail: PropTypes.string,
};

LoginPanel.defaultProps = {
  errorMessage: null,
  initialEmail: '',
};

export default LoginPanel;
